import React, { useState, useEffect, useRef, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import { AsyncPaginate } from 'react-select-async-paginate';
import "jspdf-autotable";

const RefundAnalysis = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [unitCustomers, setUnitCustomers] = useState(null); // customers of the selected unit; null = full list
    const [customerListKey, setCustomerListKey] = useState(0); // forces the customer dropdown to drop its cached options
    const latestUnitRef = useRef(null);
    const [unitLoading, setUnitLoading] = useState(false);
    const [customerLoading, setCustomerLoading] = useState(false);
    const ITEMS_PER_PAGE = 100

    const [formData, setFormData] = useState({
        property: "",
        unitNo: "",
        tanent: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchCustomerName');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
            setTanentList(res?.data?.dropdowns?.CustomerName);

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            if (!formData?.property?.value?.value) {
                toast.warning("Select Property")
                setLoader(false)
                return
            } else if (!formData?.unitNo?.label) {
                toast.warning("Select Unit")
                setLoader(false)
                return
            } else if (!formData?.tanent?.value?.value) {
                toast.warning("Select Customer")
                setLoader(false)
                return
            }
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("CustomerNo", formData?.tanent?.value?.value || "All");
            
            const res = await apiService.getApiParamater("REPORT_REFUND_ANALYSIS", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("CustomerNo", formData?.tanent?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_REFUND_ANALYSIS", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Lease No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Period From", field: "leaseDate", valueFormatter: dateFormatter, comparator: dateComparator, filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Period To", field: "leaseExpiry", valueFormatter: dateFormatter, comparator: dateComparator, filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Type", field: "paymentType", filter: true, floatingFilter: true, suppressMovable: true, width: 200, },
        {
            headerName: "Period", field: "dueDate", filter: true, floatingFilter: true, suppressMovable: true, width: 200,
            valueFormatter: (params) => {
                const LeaseDate = params?.data?.leaseDate
                const LeaseExpiry = params?.data?.leaseExpiry
                
                return (`${moment(LeaseDate).format("DD-MMM-YYYY")} _ ${moment(LeaseExpiry).format("DD-MMM-YYYY")}`);
            }
        },
        {
            headerName: "Amount Dr(INV)", field: "installmentAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
        {
            headerName: "Amount Cr", field: "amountPaid", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
        {
            headerName: "SD .Adj", field: "adjAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
        { headerName: "Receipt No", field: "receiptNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        {
            headerName: "Balance", field: "balance", filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setUnitList([])
        setUnitCustomers(null)
        setCustomerListKey(k => k + 1)
        latestUnitRef.current = null
        setUnitLoading(false)
        setCustomerLoading(false)
        setRowData([])
        setExportData([])
        setPagination()
        setFormData({
            property: "",
            tanent: "",
            movein: "Move In",
            unitNo: "",
            from: todate,
            to: todate,
            unitClass: "",
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, property: value, unitNo: null, tanent: null }));
            latestUnitRef.current = null
            setUnitCustomers(null)
            setCustomerListKey(k => k + 1)
            if (!value) {
                setUnitList([])
                return
            }
            setUnitList([])
            setUnitLoading(true)
            try {
                const params = new URLSearchParams();
                params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
                params.append('CascadValue', value?.value?.value);
                const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
                setUnitList(res?.data?.items || [])
            } finally {
                setUnitLoading(false)
            }
        } else if (name === "unitNo") {
            setFormData(prev => ({ ...prev, unitNo: value, tanent: null }));
            latestUnitRef.current = value?.value?.value ?? null
            // drop the previous unit's customers right away
            setUnitCustomers(null)
            setCustomerListKey(k => k + 1)
            if (!value) {
                // unit cleared: back to the starting customer list
                setCustomerLoading(false)
                return
            }
            setCustomerLoading(true)
            try {
                const cusparams = new URLSearchParams();
                cusparams.append('DropdownFor', 'LRASearchCustByPropertyIdAndUnit');
                cusparams.append('CascadValue', formData?.property?.value?.value);
                cusparams.append('CascadText', value?.value?.value);
                const cusRes = await apiService.getApiParamater('REPORT_CASCAD', `?${cusparams.toString()}`);
                // ignore a slow response of a unit that is no longer selected
                if (latestUnitRef.current !== value?.value?.value) return
                const items = cusRes?.data?.items
                setUnitCustomers(items?.length ? (Array.isArray(items) ? items : [items]) : null)
                setCustomerListKey(k => k + 1)
            } finally {
                if (latestUnitRef.current === value?.value?.value) setCustomerLoading(false)
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        const sourceList = unitCustomers || tanentList || [];
        let filtered = sourceList;

        if (search) {
            filtered = sourceList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    // Shared column set for both PDF and Excel exports. Field names match the
    // grid's columnDefs (camelCase) — the previous PascalCase dataKeys never
    // matched the actual API fields, so exports were pulling blanks.
    const exportColumns = [
        { header: "Lease No", getValue: (item) => normalizeValue(item?.leaseNo) },
        { header: "Period From", getValue: (item) => normalizeValue(item?.leaseDate) },
        { header: "Period To", getValue: (item) => normalizeValue(item?.leaseExpiry) },
        { header: "Type", getValue: (item) => normalizeValue(item?.paymentType) },
        {
            header: "Period",
            getValue: (item) => `${moment(item?.leaseDate).format("DD-MMM-YYYY")} _ ${moment(item?.leaseExpiry).format("DD-MMM-YYYY")}`,
        },
        { header: "Amount Dr(INV)", numeric: true, getValue: (item) => Number(item?.installmentAmount) || 0 },
        { header: "Amount Cr", numeric: true, getValue: (item) => Number(item?.amountPaid) || 0 },
        { header: "SD .Adj", numeric: true, getValue: (item) => Number(item?.adjAmount) || 0 },
        { header: "Receipt No", getValue: (item) => normalizeValue(item?.receiptNo) },
        { header: "Balance", numeric: true, getValue: (item) => Number(item?.balance) || 0 },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Refund Analysis Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => (col.numeric ? col.getValue(row).toFixed(3) : col.getValue(row)))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Refund_Analysis_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const dataRows = exportData.map(item =>
            exportColumns.map(col => col.getValue(item))
        );

        const totalsRow = exportColumns.map((col, index) => {
            if (index === 0) return "Total";
            if (col.numeric) {
                return exportData.reduce((sum, item) => sum + (Number(col.getValue(item)) || 0), 0);
            }
            return "";
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
            ["REFUND ANALYSIS REPORT"],
            exportColumns.map(col => col.header),
            ...dataRows,
            totalsRow,
        ]);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: exportColumns.length - 1 } },
        ];

        worksheet["!cols"] = exportColumns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length),
                String(totalsRow[i] ?? "").length
            );
            return { wch: Math.min(Math.max(maxLength + 3, 12), 35) };
        });

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 30 }];
        worksheet["!freeze"] = { ySplit: 2 };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
            left: { style: "thin", color: { rgb: "FFD9D9D9" } },
            right: { style: "thin", color: { rgb: "FFD9D9D9" } },
        };

        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        exportColumns.forEach((column, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF666666" } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            };
        });

        dataRows.forEach((row, r) => {
            exportColumns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;
                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: col.numeric ? "right" : "left" },
                    border: borderStyle,
                };
                if (col.numeric) {
                    cell.t = "n";
                    // Match the grid's plain toFixed(3) output — no thousand separators
                    cell.z = "0.000";
                }
            });
        });

        const totalsRowIndex = dataRows.length + 2;
        exportColumns.forEach((col, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: totalsRowIndex, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: "FFF0EDF5" } },
                alignment: { vertical: "center", horizontal: col.numeric ? "right" : "left" },
                border: borderStyle,
            };
            if (col.numeric) {
                cell.t = "n";
                cell.z = "0.000";
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Refund Analysis Report");
        XLSX.writeFile(workbook, "Refund_Analysis_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property <span className="text-danger">*</span></label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit <span className="text-danger">*</span></label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    isDisabled={!formData?.property || unitLoading}
                                    isLoading={unitLoading}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Customer <span className="text-danger">*</span></label>
                                <AsyncPaginate
                                    key={`cust-${customerListKey}`}
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    isDisabled={!formData?.unitNo || customerLoading}
                                    isLoading={customerLoading}
                                    value={formData?.tanent}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tanent", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Refund Analysis Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default RefundAnalysis;